import { render, staticRenderFns } from "./TransportName.vue?vue&type=template&id=e5faa9f4&"
import script from "./TransportName.vue?vue&type=script&lang=js&"
export * from "./TransportName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports